import React from 'react';
import { Link } from 'gatsby';
import DropdownLevelTwoItem from '../dropdownLevelTwoItem/DropdownLevelTwoItem';

const DropdownLevelOneItem = ({
  menuItem,
  handleMouseEnterLevelOne,
  activeItem,
}) => (
  <li
    onMouseEnter={() => handleMouseEnterLevelOne(menuItem)}
    className={`hover:bg-customGray-200 text-customGray-900 ${
      activeItem && activeItem.title === menuItem.title
        ? 'bg-customGray-200 first:rounded-tr-md'
        : 'bg-white rounded-md'
    }`}
  >
    <Link
      to={menuItem.href}
      className={`flex text-sm font-medium py-2 px-3 ${
        menuItem?.href?.length <= 2 ? 'cursor-default' : ''
      }`}
    >
      {menuItem.title}
    </Link>
    <DropdownLevelTwoItem menuItems={menuItem} activeId={activeItem?.id} />
  </li>
);

export default DropdownLevelOneItem;
